export const products = [
  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/Pro7.png",
    name: "Surface Pro",
    price: 29.95,
    models: [
      {
        sku: "SURFACE-PRO-7_KIT_OBD_SKIN_",
        name: "Pro 7",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Pro7/Pro7_RobotCamo.png'],
        },
      },
      {
        sku: "SURFACE-PRO-X_KIT_OBD_SKIN_",
        name: "Pro X",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/ProX/ProX_RobotCamo.png'],
        },
      },
    ],
  },

  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/Laptop3.png",
    name: "Surface Laptop",
    notice: 'Skin applies to both top and bottom of this Surface device.',
    price: 49.95,

    models: [
      {
        sku: "SURFACE-LAPTOP-3-135_KIT_OBD_SKIN_",
        name: 'Laptop 3 13.5"',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_RobotCamo.png'],
        },
      },
      {
        sku: "SURFACE-LAPTOP-3-15_KIT_OBD_SKIN_",
        name: 'Laptop 3 15"',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_RobotCamo.png'],
        },
      },
      {
        sku: "SURFACE-LAPTOP-4-135_KIT_OBD_SKIN_",
        name: 'Laptop 4 13.5"',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_RobotCamo.png'],
        },
      },
      {
        sku: "SURFACE-LAPTOP-4-15_KIT_OBD_SKIN_",
        name: 'Laptop 4 15"',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery: {
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_RobotCamo.png'],
        },
      },
    ],
  },
  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/LaptopGo.png",
    sku: "SURFACE-LAPTOP-GO_KIT_OBD_SKIN_",
    name: "Surface Laptop Go",
    notice: 'Skin applies to both top and bottom of this Surface device.',
    price: 49.95,
    gallery: {
      'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_Marty.png'],
      'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_Brooke.png'],
      // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_Cache.png'],
      'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_ColleteDavis.png'],
      'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_DJHapa.png'],
      'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_FabioViviani.png'],
      'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_MarcusRivero.png'],
      'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/LaptopGo/LaptopGo_RobotCamo.png'],
    },
  },
  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/Book3.png",
    name: "Surface Book 3",
    notice: 'Skin applies to both top and bottom of this Surface device.',
    price: 49.95,

    models: [
      {
        sku: "SURFACE-BOOK-3-135_KIT_OBD_SKIN_",
        name: '13.5”',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery:{
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_RobotCamo.png'],
        },
      },
      {
        sku: "SURFACE-BOOK-3-15_KIT_OBD_SKIN_",
        name: '15”',
        image: "https://msobd-storage.azureedge.net/images/devices-surface-laptop-3.png",
        gallery:{
          'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Marty.png'],
          'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Brooke.png'],
          // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_Cache.png'],
          'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_ColleteDavis.png'],
          'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_DJHapa.png'],
          'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_FabioViviani.png'],
          'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_MarcusRivero.png'],
          'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Book3/Book3_RobotCamo.png'],
        },
      },
    ],
  },
  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/Go2.png",
    sku: "SURFACE-GO-2_KIT_OBD_SKIN_",
    name: "Surface Go 2",
    price: 29.95,
    gallery: {
      'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_Marty.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_Marty.png'],
      'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_Brooke.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_Brooke.png'],
      // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_Cache.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_Cache.png'],
      'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_ColleteDavis.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_ColleteDavis.png'],
      'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_DJHapa.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_DJHapa.png'],
      'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_FabioViviani.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_FabioViviani.png'],
      'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_MarcusRivero.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_MarcusRivero.png'],
      'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-1_RobotCamo.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Go2/Go2-2_RobotCamo.png'],
    }
  },
  {
    image: "https://msobd-storage.azureedge.net/images/customWraps/devices/Duo.png",
    sku: "SURFACE-DUO_KIT_OBD_SKIN_",
    name: "Surface Duo",
    price: 25.95,
    gallery: {
      'CP-901': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_Marty.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_Marty.png'],
      'CP-902': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_Brooke.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_Brooke.png'],
      // 'CP-903': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_Cache.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_Cache.png'],
      'CP-904': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_ColleteDavis.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_ColleteDavis.png'],
      'CP-905': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_DJHapa.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_DJHapa.png'],
      'CP-906': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_FabioViviani.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_FabioViviani.png'],
      'CP-907': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_MarcusRivero.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_MarcusRivero.png'],
      'RP-002': ['https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-1_RobotCamo.png','https://msobd-storage.azureedge.net/images/customWraps/skinned/Duo/Duo-2_RobotCamo.png'],
    }
  },
];

export const designs = [
  {
    sku: 'CP-901',
    name: "Martellus Bennett",
    owner: "Martellus Bennett",
    slogan: 'Designed by Martellus Bennett',
    subSlogan: 'Inked to imagine',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Martellus_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Martellus_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Martellus_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Martellus_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Marty.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/Marty.jpg",
    statement: 'Some authors write. Martellus Bennett builds worlds. This design tells a new narrative inspired by fresh experiences in our everyday environments and pays tribute to what’s achievable when we follow&nbsp;our&nbsp;dreams.'
  },
  {
    sku: 'CP-902',
    name: "Brooke Shaden",
    owner: "Brooke Shaden",
    slogan: 'Inspired by Brooke Shaden',
    subSlogan: 'Put style in focus',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Brooke_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Brooke_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Brooke_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Brooke_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Brooke.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/Brooke.jpg",
    statement: 'In the eyes of Brooke Shaden, the best way to tell a unique story is to use our natural surroundings as the canvas. Using film negatives as a nod to Brooke’s art, this piece embraces her ability to reshape the physical world into an entirely&nbsp;new&nbsp;creation.'
  },
  // {
  //   sku: 'CP-903',
  //   name: "Cache Bunny",
  //   owner: "Cache Bunny",
  //   slogan: 'Inspired by Cache Bunny',
  //   subSlogan: 'Steal the scene',
  //   ownerImages: {
  //     400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Cache_blade_SV.jpg',
  //     1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Cache_blade_S.jpg',
  //     1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Cache_blade_M.jpg',
  //     default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Cache_blade_L.jpg',
  //   },
  //   productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_Cache.png',
  //   swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/Cache.jpg",
  //   statement: 'For Cache Bunny, creativity isn’t just about doing something new. It’s about showcasing your unique perspective. As a tribute to looking at the world through new eyes, this piece uses Cache’s distinct and world-bending style&nbsp;as&nbsp;inspiration.'
  // },
  {
    sku: 'CP-904',
    name: "Collete Davis",
    owner: "Collete Davis",
    slogan: 'Inspired by Collete Davis',
    subSlogan: 'Speed meets style',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Collete_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Collete_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Collete_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Collete_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_ColleteDavis.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/ColleteDavis.jpg",
    statement: 'Collete Davis lives for speed in style. It’s a passion turned art form that’s been perfected through years of practice. In a nod to her life in top gear, this design draws from the smooth curves imprinted on the pavement by drifting tires and Collete’s&nbsp;bright&nbsp;personality. '
  },
  {
    sku: 'CP-905',
    name: "DJ HAPA",
    owner: "DJ HAPA",
    slogan: 'Inspired by DJ HAPA',
    subSlogan: 'Live at full volume',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Hapa_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Hapa_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Hapa_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Hapa_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_DJHapa.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/DJHapa.jpg",
    statement: 'DJ HAPA isn’t just a talented musician. He’s an educator, thought leader, and innovative performer who uses the cutting-edge of music and technology to inspire others, and he’s been at it for over 20 years. This design was inspired by his personal mantra of following your heart, embracing your passion, and living life to&nbsp;its&nbsp;fullest.'
  },
  {
    sku: 'CP-906',
    name: "Fabio Viviani",
    owner: "Fabio Viviani",
    slogan: 'Inspired by Fabio Viviani',
    subSlogan: 'Cook up a new style',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Fabio_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Fabio_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Fabio_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Fabio_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_FabioViviani.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/FabioViviani.jpg",
    statement: 'Cooking is an art, and chef Fabio Viviani’s palette is full of the colorful flavors of the world. Like all artists, Fabio blends them together in fresh ways to make original masterpieces…which in his case, are just as beautiful as they are delicious. The design behind this skin celebrates the vivid rainbow palette of spices and sizzling pans he uses in&nbsp;the&nbsp;kitchen. '
  },
  {
    sku: 'CP-907',
    name: "Marcus Rivero",
    owner: "Marcus Rivero",
    slogan: 'Designed by Marcus Rivero',
    subSlogan: 'Style with sole',
    ownerImages: {
      400: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Marcus_blade_SV.jpg',
      1024: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Marcus_blade_S.jpg',
      1350: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Marcus_blade_M.jpg',
      default: 'https://msobd-storage.azureedge.net/images/customWraps/creators/Marcus_blade_L.jpg',
    },
    productImage: 'https://msobd-storage.azureedge.net/images/customWraps/skinned/Laptop3/Laptop3_MarcusRivero.png',
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/MarcusRivero.jpg",
    statement: 'Marcus Rivero pours his soul into every pair of soles he creates. An artistic visionary driven by a love of sports, he uses his favorite brushes to craft vibrant, custom cleats a step above the rest. This Surface design embodies his signature style with bright, air-brushed colors, and pays homage to his process of experimenting with bold&nbsp;new&nbsp;mediums.'
  },
  {
    sku: 'RP-002',
    name: "Robot Camo",
    owner: "dbrand",
    slogan: 'Designed by dbrand',
    subSlogan: 'Artful intelligence',
    ownerImages: null,
    swatch: "https://msobd-storage.azureedge.net/images/customWraps/swatches/RobotCamo.jpg",
    statement: 'Who says you can’t be a robot and an original? This Robot Camo design proves you can. With a future-forward style inspired by tech, for tech, it’s a millennium ahead of its time—just like you and what you create on Surface.'
  },
];

export const finishes = [
  {
    name: "Ultramatte",
    sku: ''
  },
  {
    name: "Glossy",
    sku: ''
  },
  {
    name: "None",
    sku: ''
  }
];

/**
 Headline 1)
 Choose Your Product

     Surface Duo
     Surface Pro
     Surface Go
     Surface Laptop 3
     Surface Laptop Go
     Surface Book 3

 (Headline 2)
 Choose Your Model (these results depend on what’s chosen above)

     Surface Pro X
     Surface Pro 7

     Surface Laptop 3 13.5"
     Surface Laptop 3 15"

     Surface Book 3 13.5"
     Surface Book 3 15"


 (Headline 3)
 Logo Display

     Show Logo
     Hide Logo

 (Headline 4)
 Skin Finish

     Ultramatte
     Glossy
     None

 **/
